export default function Footer() {
  return (
    <footer className="text-center">
      <p style={{ fontSize: "0.9rem" }}>
        &copy; 2025 Matt Bongiovi. All rights reserved.
      </p>
    </footer>
  );
}
